export const openModal = ({ commit }, data) => {
    const {
        name,
        payload = null,
    } = data;

    commit('setOpenedModal', name);
    commit('setOpenedModalPayload', payload);
}